import React, { Component } from 'react';
import { 
  Accordion, 
  Grid, 
  GridColumn, 
  GridRow, 
  Icon,
} from 'semantic-ui-react';

export default class Faq extends Component {
  state = { activeIndex: 0 }

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  }

  render() {
    const { activeIndex } = this.state;

		const pStyle = {
			fontFamily: "'Andika', sans-serif",
			color: "#8C8C8C",
			fontSize: "1.1em",
		}

    return (
			<Grid container centered style={{ padding: "0em 0em 10em 0em" }}>
				<GridRow>
					<GridColumn textAlign='center'>
						<Accordion>
							<Accordion.Title
								id="faq1"
								active={activeIndex === 0}
								index={0}
								onClick={this.handleClick}
								style={pStyle}
							>
								<Icon name='dropdown' />
								Where do you source your timber?
							</Accordion.Title>
							<Accordion.Content 
								id="faq1-content"
								active={activeIndex === 0}
							>
								<p style={pStyle}>
									Our unique Tasmanian timber supplies are sourced through certified dealers.
								</p>
							</Accordion.Content>
							<br/>

							<Accordion.Title
								id="faq2"
								active={activeIndex === 1}
								index={1}
								onClick={this.handleClick}
								style={pStyle}
							>
								<Icon name='dropdown' />
								Will my product look exactly like the picture?
							</Accordion.Title>
							<Accordion.Content 
								id="faq2-content"
								active={activeIndex === 1}
							>
								<p style={pStyle}>
									All our products are hand made from natural timbers therefore, colour and grain 
									will vary.
								</p>
							</Accordion.Content>
							<br/>

							<Accordion.Title
								id="faq3"
								active={activeIndex === 2}
								index={2}
								onClick={this.handleClick}
								style={pStyle}
							>
								<Icon name='dropdown' />
								How much time between order and delivery?
							</Accordion.Title>
							<Accordion.Content 
								id="faq3-content"
								active={activeIndex === 2}
							>
								<p style={pStyle}>
									For stock items 7-14 days. For custom items, please email us for an estimated 
									delivery date.
								</p>
							</Accordion.Content>
							<br/>

							<Accordion.Title
								id="faq4"
								active={activeIndex === 3}
								index={3}
								onClick={this.handleClick}
								style={pStyle}
							>
								<Icon name='dropdown' />
								How do I care for my Splinters piece?
							</Accordion.Title>
							<Accordion.Content 
								id="faq4-content"
								active={activeIndex === 3}
							>
								<p style={pStyle}>
									Care instructions will be included with your purchase.
								</p>
							</Accordion.Content>
							<br/>

							<Accordion.Title
								id="faq5"
								active={activeIndex === 4}
								index={4}
								onClick={this.handleClick}
								style={pStyle}
							>
								<Icon name='dropdown' />
								Can I choose my resin colour?
							</Accordion.Title>
							<Accordion.Content 
								id="faq5-content"
								active={activeIndex === 4}
							>
								<p style={pStyle}>
									Yes you can, we have a selection of resin colours for you to choose from.
								</p>
							</Accordion.Content>
							<br/>

							<Accordion.Title
								id="faq6"
								active={activeIndex === 5}
								index={5}
								onClick={this.handleClick}
								style={pStyle}
							>
								<Icon name='dropdown' />
								Do you ship your products?
							</Accordion.Title>
							<Accordion.Content 
								id="faq6-content"
								active={activeIndex === 5}
							>
								<p style={pStyle}>
									Yes we do, contact us to find out more about our custom shipping solutions.
								</p>
							</Accordion.Content>
							<br/>

							<Accordion.Title
								id="faq7"
								active={activeIndex === 6}
								index={6}
								onClick={this.handleClick}
								style={pStyle}
							>
								<Icon name='dropdown' />
								Can I choose my table design?
							</Accordion.Title>
							<Accordion.Content 
								id="faq7-content"
								active={activeIndex === 6}
							>
								<p style={pStyle}>
									We have the flexibility to allow you to choose your designs. Please note there 
									can be some limitations.
								</p>
							</Accordion.Content>
						</Accordion>
				</GridColumn>
				</GridRow>
			</Grid>
    )
  }
}